import React from "react";
import { navigate } from "gatsby";
import Autosuggest from "react-autosuggest";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import PropTypes from "prop-types";
import SearchPic from "./searchicon.png";

/* eslint-disable */

const styles = (theme) => ({
  root: {
    height: 250,
    flexGrow: 1,
  },
  container: {
    position: "relative",
  },
  suggestionsContainerOpen: {
    position: "absolute",
    zIndex: 1,
    overflow: "auto",
    width: "auto",
    maxHeight: 500,
    maxWidth: 900,
    marginTop: theme.spacing.unit,
    left: 5,
    right: 5,
  },

  suggestion: {
    display: "block",
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none",
  },

  search: {
    position: "absolute",
    top: 0,
    zIndex: 10020,
  },

  input: {
    width: "20vw",
    backgroundImage: "url(" + SearchPic + ")",
    backgroundSize: 18,
    backgroundPosition: [10, 15],
    backgroundRepeat: "no-repeat",
    justifyContent: "flex-start",
    outline: "none",
    border: "none",
    fontSize: 15,
    paddingLeft: 40,
    order: 2,
    paddingTop: 10,
    paddingLeft: 35,
    color: "gray",
    padding: 10,
    height: 30,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
});

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query: "",
      results: [],
      suggestionsBank: this.props.data
        .filter((item) => item.slug !== "" && item.slug !== "404")
        .map((item) => {
          return {
            title: item.frontmatter.title,
            path: item.slug,
            description: item.frontmatter.description,
            body: item.rawBody,
          };
        }),
      suggestions: [],
      value: "",
    };
  }

  escapeRegexCharacters = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  getSuggestions = (value) => {
    const escapedValue = this.escapeRegexCharacters(value.trim());
    if (escapedValue === "") {
      return [];
    }
    const valueArray = value.split(" ");
    const escapedValues = valueArray.map((wordValue) => {
      return this.escapeRegexCharacters(wordValue.trim());
    });
    const regex = new RegExp(escapedValues.join("|"), "i");
    return this.state.suggestionsBank.filter((suggest) =>
      regex.test(suggest.title) || regex.test(suggest.body)
    );
  };

  getSuggestionValue = (suggestion) => {
    return suggestion.title.toLowerCase();
  };

  renderSuggestion = (suggestion, { query, isHighlighted }) => {
    const matches = match(suggestion.title, query);
    const parts = parse(suggestion.title, matches);
    const path = suggestion.path;

    return (
      <MenuItem
        selected={isHighlighted}
        component='div'
        onClick={(e) => {
          navigate("/" + path);
        }}
      >
        <div>
          {parts.map((part, index) => {
            return part.highlight ? (
              <span
                key={String(index)}
                style={{ fontWeight: 500, color: "#0099ff" }}
              >
                {part.text}
              </span>
            ) : (
              <strong key={String(index)} style={{ fontWeight: 300 }}>
                {part.text}
              </strong>
            );
          })}
        </div>
      </MenuItem>
    );
  };

  onChange = (event, { newValue }) => {
    event.preventDefault();
    this.setState({
      value: newValue,
      query: newValue,
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };
  onSuggestionSelected = (
    event,
    { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }
  ) => {
    if (method === "enter") {
      navigate("/" + suggestion.path);
    }
  };
  render() {
    const { value } = this.state;
    const { classes } = this.props;

    const inputProps = {
      placeholder: "Search Documentation",
      value,
      onChange: this.onChange,
    };

    const autosuggestProps = {
      suggestions: this.state.suggestions,
      onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
      onSuggestionsClearRequested: this.onSuggestionsClearRequested,
      getSuggestionValue: this.getSuggestionValue,
      renderSuggestion: this.renderSuggestion,
      onSuggestionSelected: this.onSuggestionSelected,
      onSuggestionsClearRequested: () => {
        this.setState({ value: "" });
      },
    };

    return (
      <Autosuggest
        {...autosuggestProps}
        inputProps={inputProps}
        theme={{
          input: classes.input,
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion,
        }}
        renderSuggestionsContainer={(options) => (
          <Paper {...options.containerProps} square>
            {options.children}
          </Paper>
        )}
      />
    );
  }
}

Search.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Search);
